import React from "react";
export const menus = [
  {
    code: "016",
    en: "Dashboard",
    fa: "داشبورد",
    icon: <i className="fas fa-columns" />,
    link: "/dashboard",
    child: [
      // {
      //   code: "017",
      //   en: "My Representative Position",
      //   fa: "وضعیت نمایندگی من",
      //   link: "/mymepresentativeposition"
      // },
      // {
      //   code: "018",
      //   en: "E-Wallet ( Balance in E-wallet )",
      //   fa: "کیف پول",
      //   link: "/dashboard"
      // },
      // {
      //   code: "019",
      //   en: "Compensation Summary",
      //   fa: "خالصه پاداش ها",
      //   link: "/nopage"
      // },
      // {
      //   code: "020",
      //   en: "Atlantis Shopping Center",
      //   fa: "مرکز خرید آتالنتیس",
      //   link: "/nopage"
      // },
      // {
      //   code: "021",
      //   en: "Directly sponsored",
      //   fa: "معرفی های مستقیم",
      //   link: "/nopage"
      // },
      // {
      //   code: "022",
      //   en: "Bonus earned This week",
      //   fa: "درآمدهای این هفته",
      //   link: "/nopage"
      // },
      // {
      //   code: "023",
      //   en: "Total Bonus Earned",
      //   fa: "درآمد کل",
      //   link: "/nopage"
      // },
      // {
      //   code: "024",
      //   en: "My Rank / Next Rank",
      //   fa: "رنک من / رنک بعدی من",
      //   link: "/nopage"
      // },
      // {
      //   code: "025",
      //   en: "Inbox",
      //   fa: "صندوق پیام",
      //   link: "/nopage"
      // },
      // {
      //   code: "026",
      //   en: "Sales Representative",
      //   fa: "نمایندگان فروش",
      //   link: "/nopage"
      // },
      // {
      //   code: "027",
      //   en: "Commercial Representative",
      //   fa: "نمایندگان تجاری",
      //   link: "/nopage"
      // },
      // {
      //   code: "028",
      //   en: "Promotion Tools",
      //   fa: "ابزارهای تبلیغاتی",
      //   link: "/nopage"
      // },
      // {
      //   code: "029",
      //   en: "News and Activities",
      //   fa: "اخبار و فعالیت های شرکت",
      //   link: "/nopage"
      // },
      // {
      //   code: "030",
      //   en: "Schedule & Events",
      //   fa: "تقویم و رویدادها",
      //   link: "/nopage"
      // },
      // {
      //   code: "031",
      //   en: "Atlantis Stock diagram & charts",
      //   fa: "چارت ها و نمواردهای اطالعات سهام آتالنتیس",
      //   link: "/nopage"
      // }
    ]
  },
  {
    code: "032",
    en: "My Profile",
    fa: "پروفایل",
    link: null,
    icon: <i className="fas fa-user" />,
    child: [
      {
        code: "033",
        en: "Main Information",
        fa: "اطلاعات اصلی",
        link: "/maininformation"
      },
      {
        code: "034",
        en: "My Representative Positoin",
        fa: "وضعیت نمایندگی من",
        link: "/mymepresentativeposition"
      },
      {
        code: "035",
        en: "Payment Details",
        fa: "جزئیات پرداخت",
        link: "/PaymentMethods"
      },
      {
        code: "036",
        en: "KYC",
        fa: "احراز هویت",
        link: "/kyc"
      },
      {
        code: "037",
        en: "My Beneficiary Profile",
        fa: "پروفایل و مشخصات وارث من",
        link: "/mybeneficyprofile"
      },
      {
        code: "038",
        en: "Security",
        fa: "امنیت",
        link: "/security"
      },
      // {
      //   code: "493",
      //   en: "Upgrade to Commercial",
      //   fa: "ارتقا به حالت تجاری",
      //   link: "/Upgrade"
      // }
    ]
  },
  // {
  //   code: "038",
  //   en: "Security",
  //   fa: "امنیت",
  //   link: null,
  //   icon: <i className="fas fa-shield-alt" />,
  //   child: [
  //     {
  //       code: "038",
  //       en: "Security",
  //       fa: "امنیت",
  //       link: "/security"
  //     }
  //     // {
  //     //   code: "040",
  //     //   en: "PassWords",
  //     //   fa: "پسوردها",
  //     //   link: "/nopage"
  //     // }
  //   ]
  // },
  {
    code: "041",
    en: "My Network",
    fa: "شبکه",
    link: null,
    icon: <i className="fas fa-network-wired" />,
    child: [
      {
        code: "042",
        en: "Add New Member",
        fa: "اضافه کردن اعضای جدید",
        link: "/addmember"
      },
      {
        code: "043",
        en: "Network Explorer",
        fa: "جستجوی شبکه",
        link: "/networkexplorer"
      },
      // {
      //   code: "044",
      //   en: "Downlines and Spillovers",
      //   fa: "زیرمجموعه ها",
      //   link: "/downlinemember"
      // },
      {
        code: "045",
        en: "Genealogy Tree",
        fa: "نمایش درختی مجموعه",
        link: "/genealogy"
      },
      {
        code: "046",
        en: "Direct Referalls",
        fa: "معرفی های مستقیم",
        link: "/directreferall"
      },
      // {
      //   code: "178",
      //   en: "Startup Referalls",
      //   fa: "معرفی های تازه",
      //   link: "/startupreferall"
      // },
      {
        code: "047",
        en: "Lead Capturing",
        fa: "رصد سازمان فروش",
        link: "/LeadCapturing"
      }
      // {
      //   code: "048",
      //   en: "Rank Analysis",
      //   fa: "آنالیز رنک ها و درجات اعضای سازمان",
      //   link: "/nopage"
      // },
      // {
      //   code: "132",
      //   en: "Products",
      //   fa: "محصولات",
      //   link: "/products"
      // }
    ]
  },
  {
    code: "049",
    en: "Shopping Center",
    fa: "خرید کردن",
    link: null,
    icon: <i className="fas fa-shopping-basket" />,
    child: [
      {
        code: "050",
        en: "Go to Atlantis Shopping Center",
        fa: "برو به مرکز خرید آتالنتیس",
        link: "/nopage"
      },
      {
        code: "051",
        en: "Purchase history",
        fa: "تاریخچه خرید",
        link: "/PurchaseHistory"
      }
      // {
      //   code: "052",
      //   en: "Investment Contacts",
      //   fa: "قراردادهای سرمایه گذاری",
      //   link: "/nopage"
      // },
      // {
      //   code: "053",
      //   en: "Shipping & Delivery",
      //   fa: "ارسال و دلیوری",
      //   link: "/nopage"
      // }
    ]
  },
  {
    code: "054",
    en: "Bonus",
    fa: "پاداش ها",
    link: null,
    icon: <i className="fas fa-award" />,
    child: [
      {
        code: "055",
        en: "Network bonus",
        fa: "پاداش تیمی",
        link: "/networkbonus"
      },
      {
        code: "056",
        en: "Direct Sales Bonus",
        fa: "پاداش تک سطحی",
        link: "/directsalebonus"
      },
      {
        code: "057",
        en: "Rank Bonus",
        fa: "رنک پاداش",
        link: "/rankbonus"
      },
      {
        code: "058",
        en: "Flash out table",
        fa: "جدول سقف درآمدی",
        link: "/flashout"
      },
      {
        code: "059",
        en: "Vouchers",
        fa: "امتیاز سهام ها",
        link: "/vouchers"
      }
    ]
  },
  {
    code: "060",
    en: "E-Wallet",
    fa: "کیف پول الکترونیک",
    link: null,
    icon: <i className="fas fa-wallet" />,
    child: [
      {
        code: "368",
        en: "Payment Details",
        fa: "جزئیات پرداخت",
        link: "/nopage"
      },
      {
        code: "061",
        en: "E-Wallet Summary",
        fa: "خلاصه کیف پول",
        link: "/nopage"
      },
      {
        code: "062",
        en: "Transaction History",
        fa: "تاریخچه تراکنشها",
        link: "/nopage"
      },
      // {
      //   code: "063",
      //   en: "Earnings & Inward Funds",
      //   fa: "درآمدها و بودجه داخلی",
      //   link: "/nopage"
      // },
      {
        code: "064",
        en: "Withdrawals Funds",
        fa: "وجوه برداشت",
        link: "/nopage"
      },
      // {
      //   code: "065",
      //   en: "Withdraw fund from E-Wallet",
      //   fa: "خارج کردن پول از کیف پول الکترونیک",
      //   link: "/nopage"
      // },
      // {
      //   code: "066",
      //   en: "My Withdrawal Requests",
      //   fa: "درخواست های واریز پول من",
      //   link: "/nopage"
      // },
      // {
      //   code: "067",
      //   en: "Payout Preference",
      //   fa: "اولویت پرداخت",
      //   link: "/nopage"
      // },
      {
        code: "068",
        en: "Transfer Fund",
        fa: "انتقال پول",
        link: "/nopage"
      }
      // {
      //   code: "069",
      //   en: "Transaction Password",
      //   fa: "رمز عبور تراکنش ها",
      //   link: "/nopage"
      // }
    ]
  },
  {
    code: "070",
    en: "Stock & investment Managment",
    fa: "مدیریت سهام و سرمایه گذاری",
    link: null,
    icon: <i className="fas fa-calculator" />,
    child: [
      {
        code: "071",
        en: " Stock Management",
        fa: "مدیریت سهام",
        link: "/nopage"
      },
      {
        code: "369",
        en: " Investment Management",
        fa: "مدیریت سرمایه گذاری",
        link: "/nopage"
      }
    ]
  },
  // {
  //   code: "072",
  //   en: "Reports",
  //   fa: "گزارش ها",
  //   link: null,
  //   icon: <i className="fas fa-money-check-alt" />,
  //   child: [
  //     {
  //       code: "073",
  //       en: "Active Payout",
  //       fa: "پرداخت فعال",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "074",
  //       en: "Turn Over",
  //       fa: "گردش مالی",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "075",
  //       en: "Payout in Remittance",
  //       fa: "پرداخت در انتقال",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "076",
  //       en: "Payouts History",
  //       fa: "تاریخچه پرداخت ها",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "077",
  //       en: "Payout / Withdrwal in process",
  //       fa: "خروجی های در حال انجام",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "078",
  //       en: "Upgrade History",
  //       fa: "تاریخچه آپگریدها",
  //       link: "/nopage"
  //     }
  //   ]
  // },
  {
    code: "370",
    en: "Sale engineering",
    fa: "مهندسی فروش",
    link: null,
    icon: <i className="fas fa-address-card" />,
    child: [
      {
        code: "080",
        en: "CRM",
        fa: "مدیریت مشتری",
        link: "/nopage"
      },
      {
        code: "081",
        en: "Promotional Tools",
        fa: "ابزارهای تبلیغاتی",
        link: "/PromotionTools"
      },
      {
        code: "087",
        en: "Brandig Materials",
        fa: "آیتم های برندینگ شرکت",
        link: "/brandingMaterials"
      },
      {
        code: "089",
        en: "Business Presentations",
        fa: "ارائه کسب و کار",
        link: "/productAndBusinessPresentations"
      }
    ]
  },
  // {
  //   code: "081",
  //   en: "Promotion Tools",
  //   fa: "ابزارهای تبلیغاتی",
  //   link: null,
  //   icon: <i className="fas fa-ad" />,
  //   child: [
  //     {
  //       code: "083",
  //       en: "Referral Link",
  //       fa: "لینک معرفی",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "084",
  //       en: "Digital & Social Marketing tools",
  //       fa: "ابزارهای دیجیتال مارکتینگ و سوشیال مارکتینگ",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "085",
  //       en: "SMS Panel",
  //       fa: "پنل sms گروهی",
  //       link: "/nopage"
  //     }
  //   ]
  // },
  {
    code: "090",
    en: "Compliance",
    fa: "قراردادها و تفاهم نامه ها",
    link: null,
    icon: <i className="fas fa-copy" />,
    child: [
      {
        code: "091",
        en: "My Contract",
        fa: "قرارداد بازاریابی",
        link: "/MyContract"
      },
      {
        code: "092",
        en: "Audit",
        fa: "بازرسی / حسابرسی",
        link: "/audit"
      },
      {
        code: "093",
        en: "Legal documents",
        fa: "اسناد حقوقی",
        link: "/legalDocuments"
      },
      {
        code: "240",
        en: "Terms and Condition",
        fa: "قوانین و مقررات",
        link: "/termsAndCondition"
      },
      {
        code: "095",
        en: "Privacy Policy",
        fa: "سیاست های حریم خصوصی",
        link: "/privacyPolicy"
      },
      {
        code: "096",
        en: "Access Request form",
        fa: "دسترسی به فرم های درخواست",
        link: "/accessRequestFrom"
      },
      {
        code: "097",
        en: "Consent Withdrawal form",
        fa: "فرم موافقت / رضایت زدن خروجی به حساب",
        link: "/ConsentWithdrawal"
      }
      // {
      //   code: "094",
      //   en: "IMA Policy",
      //   fa: "سیاست های تازه واردان",
      //   link: "/nopage"
      // },
    ]
  },
  {
    code: "098",
    en: "Information & Education Center",
    fa: "مرکز اطلاعات و آموزش",
    link: null,
    icon: <i className="fas fa-question-circle" />,
    child: [
      {
        code: "099",
        en: "Education Platform",
        fa: "پلت فرم آموزش",
        link: "/informationAndEducationCenter/educationPlatform"
      },
      {
        code: "100",
        en: "News",
        fa: "اخبار",
        link: "/nopage"
      },
      {
        code: "263",
        en: "Events",
        fa: "رخدادها",
        link: "/informationAndEducationCenter/Events"
      }
    ]
  },
  // {
  //   code: "101",
  //   en: "Resources",
  //   fa: "منابع",
  //   link: null,
  //   icon: <i className="fas fa-archive" />,
  //   child: [
  //     {
  //       code: "102",
  //       en: "IMA tools",
  //       fa: "ابزارهای آموزش و راه اندازی افراد تازه وارد",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "103",
  //       en: "Video",
  //       fa: "ویدیو",
  //       link: "/nopage"
  //     },
  //     {
  //       code: "104",
  //       en: "Webinars",
  //       fa: "وبینار",
  //       link: "/nopage"
  //     }
  //   ]
  // },
  // {
  //   code: "105",
  //   en: "Inbox",
  //   fa: "صندوق پیام",
  //   link: null,
  //   icon: <i className="fas fa-inbox" />,
  //   child: [
  //     {
  //       code: "106",
  //       en: "Inbox",
  //       fa: "صندوق پیام",
  //       link: "/nopage"
  //     }
  //   ]
  // },
  {
    code: "107",
    en: "Support",
    fa: "پشتیبانی",
    link: null,
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "106",
        en: "Messages",
        fa: "پیام ها",
        link: "/Messages"
      },
      {
        code: "108",
        en: "Live chat",
        fa: "چت زنده ",
        link: "/chat"
      },
      {
        code: "111",
        en: "Whistle Blower Report",
        fa: "گزارش تخلف",
        link: "/WhistleBlowerReport"
      }
      // {
      //   code: "109",
      //   en: "Support Request",
      //   fa: "درخواست پشتیبانی",
      //   link: "/nopage"
      // },
      // {
      //   code: "110",
      //   en: "My Support Requests & Resolutions",
      //   fa: "سابقه درخواست های پشتیبانی من و پاسخ ها",
      //   link: "/nopage"
      // },
    ]
  },
  {
    code: "267",
    en: "UnSubscribe",
    fa: "لغو عضویت",
    link: "/UnSubscribe",
    icon: <i className="fas fa-headset" />,
    child: []
  }
];
export default menus;
